import React from 'react'

import Image from 'next/image'

import { ContentSection } from 'src/common/components/ContentSection/ContentSection'
import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'

import historyImg from './historyImg.png'
import { HistoryTagIcon } from './HistoryTagIcon'

import s from './AboutHistoryBlock.module.scss'

export type AboutHistoryBlockProps = {}

export const AboutHistoryBlock: React.FC<AboutHistoryBlockProps> = () => {
  return (
    <ContentSection className={s.AboutHistoryBlock}>
      <div className={s.AboutHistoryBlock__img}>
        <Image
          src={historyImg.src}
          layout="fill"
          objectFit="cover"
          alt=""
          unoptimized
        />

        <div className={s.AboutHistoryBlock__imgTag}>
          <div className={s.AboutHistoryBlock__imgTagInner}>
            <HistoryTagIcon />

            <div className={s.AboutHistoryBlock__imgTagText}>
              Insquad team on Emerge conference
            </div>
          </div>
        </div>
      </div>

      <Typography
        variant={EnumTypographyVariants.H2}
        text="Insquad story"
        className={s.AboutHistoryBlock__title}
      />

      <Typography
        variant={EnumTypographyVariants.H6}
        as="p"
        text="Back in 2015, one tech startup CEO and founder needed to scale his software development team. It took him six month and hundreds of dollars to complete this task; after multiple unsuccessful attempts to hire in-house software developers he decided to consider remote workers—and it was a great solution. It was Alex Svinov, co-founder and CEO at Insquad.
        Facing all the pain points startup founders have, Alex started Insquad to"
        className={s.AboutHistoryBlock__description}
      />

      <Typography
        variant={EnumTypographyVariants.H6}
        as="p"
        text="help companies quickly hire senior remote developers worldwide. To bring this big idea to life he has joined forces with tech professional Rinat Khatipov and marketing expert German Pundrovski—co-founders at Insquad. That’s how the story begins!"
        className={s.AboutHistoryBlock__descriptionBottom}
      />
    </ContentSection>
  )
}
